function Social(){
    return(
        <div className="containerSocial">
           <a href  = "https://www.instagram.com/guru.yogastudio/?hl=en" target = '_blank' rel="noreferrer" > <img className="icon" src = {"https://cdn-icons-png.flaticon.com/512/174/174855.png?w=1060&t=st=1674797200~exp=1674797800~hmac=1a9c3fae6e1c74161ec2a40707b2b6297d48699d584f6081227d70e9978c1575"}
            width="50px" alt='insta'/></a> 
        </div>
    )
}

export default Social;